import { Card } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

export default function CourseCardSkeleton() {
  return (
    <Card className="flex h-[120px] w-full flex-row">
      <div className="flex h-full w-full flex-row overflow-hidden rounded-lg">
        <div className="min-w-1">
          <Skeleton className="h-full w-[8px]" />
        </div>
        <div className="flex h-full w-full flex-col p-4">
          <div className="flex flex-row">
            <Skeleton className="h-4 w-2/3" />
          </div>
          <div className="mt-2 flex w-full flex-row gap-2">
            <div className="flex flex-1 flex-col justify-end gap-2">
              <Skeleton className="h-4 w-full" />
              <div className="flex items-center gap-1">
                <Skeleton className="h-4 w-6" />
                <Skeleton className="h-4 w-16" />
              </div>
            </div>
            <div className="flex flex-col items-end justify-end">
              <Skeleton className="h-8 w-8 rounded-full" />
              <Skeleton className="mt-1 h-4 w-16" />
            </div>
          </div>
        </div>
      </div>
    </Card>
  )
}
